import { AssetDTO } from 'config/api/assets/assets.types';

const assetOptionsParser = ({ results }: { results: AssetDTO[] }) =>
  results.map(({ id, name, category, owner }) => {
    const ownerName = owner?.profile ? `${owner.profile.first_name} ${owner.profile.last_name}`.trim() || owner.email : owner?.email || '';

    return {
      key: id,
      id,
      name,
      category: [category.name_translation_key, category.name],
      owner: ownerName,
    };
  });
export default assetOptionsParser;
